import { OfferService } from '@spilca/order_ts/v1/order_web/offer_web_pb_service';
import { getOffersWrapperRequestConstructor } from '@monorepo/offers';

const getOffersWrapper = (filter: object | undefined) =>
  getOffersWrapperRequestConstructor(filter, OfferService.ListOfferWrapped);

export default getOffersWrapper;
